import { ThemeNames } from '@smb/fabric-teams-theme';
import { teamsSdk } from '../teams-sdk/teamsSdk';

export const onThemeChangeListener = (
  onThemeChange: (themeName: ThemeNames) => Promise<void>
): void => {
  teamsSdk.registerOnThemeChangeHandler(
    onThemeChange as (themeName: string) => Promise<void>
  );
};
